export const settings = {
  setShareTitle: 'Deel App',
  setNotifiationsTitle: 'Meldingen',
  setContactAppOwnerTitle: 'Neem contact op met app-eigenaar',
  setContactDevelopersTitle: 'Neem contact op met ontwikkelaars',
  setReportAppTitle: 'App rapporteren',
  setDeleteAccountTitle: 'Account verwijderen',
  setLogOutTitle: 'Uitloggen',
  setShareAppCurtainTitle: 'Deel App',
  setShareAppCurtainButtonTitle: 'Kopieer link',
  setShareAppAlertWhenAppLinkWasCopied: 'Link gekopieerd!',
  setNotificationsInAppTitle: 'In-app',
  setNotificationsPushContent: 'Push',
  setNotificationsChatsTitle: 'Chats',
  setNotificationsDiscussionsTitle: 'Discussies',
  setNotificationsNewsTitle: 'Nieuwsfeed',
  setNotificationsEventsTitle: 'Evenementen',
  setNotificationsAdminTitle: 'Beheerdersberichten',
  setNotificationsBlogTitle: 'Blog',
  setNotificationsPushOffContent: 'Pushmeldingen zijn uitgeschakeld',
  setNotificationsPushOffText: 'Om meldingen in te schakelen, ga naar de instellingen van je apparaat en schakel meldingen in',
  setReportAppFlagCurtainTitle: 'Rapporteren',
  setAppReportedCurtainContent: 'Inhoud gerapporteerd',
  setDeleteCurtainTitle: 'Account verwijderen',
  setDeleteCurtainInputContent: 'Wachtwoord',
  setDeleteCurtainCancelButtonTitle: 'Annuleren',
  setDeleteCurtainConfirmButtonTitle: 'Bevestigen',
  setDeleteCurtainIncorrectPasswordAlertText: 'Wachtwoord is onjuist',
  setTurnNotificationsOnText: 'Om ze in te schakelen, klik op de knop hieronder en sta het ontvangen van meldingen toe.',
  setTurnNotificationsOnButton: 'Zet pushmeldingen aan'
}
